<template>
    <el-menu
            :default-active.sync="activeLink"
            :mode="mode"
            @select="goto"
            :collapse="isCollapse"
            :unique-opened="true"
            background-color="transparent"
            class="main-navigation-menu"
            :class="{'nav-collapsed':isCollapse}">
        <div class="el-menu-item-group__title" style="padding-top: 4px;"><span>Genel Bilgiler</span></div>
        <el-menu-item index="/profile">
            <i class="mdi mdi-account-card-details"></i><span slot="title">Kişisel Bilgilerim</span>
        </el-menu-item>
        <!--<el-menu-item  index="/firma/detay">-->
            <!--<i class="mdi mdi-city"></i><span slot="title">Firma Bilgilerim</span>-->
        <!--</el-menu-item>-->
        <el-submenu  index="firma" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-city"></i><span>Firma Bilgileri</span>
            </template>
            <el-menu-item v-if="root" index="/firma/tanimlama">
                <span slot="title">Tanımla</span>
            </el-menu-item>
            <el-menu-item index="/firma/detay">
                <span slot="title">Detay</span>
            </el-menu-item>
            <el-menu-item index="/firma/yoneticitanimlama">
                <span slot="title">Yönetici Tanımla</span>
            </el-menu-item>
            <el-menu-item index="/firma/yoneticiListesi">
                <span slot="title">Yönetici Listesi</span>
            </el-menu-item>
        </el-submenu>
        <el-submenu index="sayfa" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-page-next"></i><span>Sayfalar</span>
            </template>
            <el-menu-item index="/sayfa/tanimlama">
                <span slot="title">Tanımla</span>
            </el-menu-item>
            <el-menu-item index="/sayfa/liste">
                <span slot="title">Liste</span>
            </el-menu-item>
        </el-submenu>
        <el-submenu index="urun" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-door-open"></i><span>Ürünler</span>
            </template>
            <el-menu-item index="/urun/tanimlama">
                <span slot="title">Tanımla</span>
            </el-menu-item>
            <el-menu-item index="/urun/liste">
                <span slot="title">Liste</span>
            </el-menu-item>
            <el-submenu index="/urun/kategori">
                <template slot="title">Kategoriler</template>
                <el-menu-item index="/urun/kategori/tanimlama">Kategori Ekle</el-menu-item>
                <el-menu-item index="/urun/kategori/liste">Kategori Liste</el-menu-item>
            </el-submenu>
            <el-submenu index="/urun/opsiyon">
                <template slot="title">Opsiyonlar</template>
                <el-menu-item index="/urun/opsiyon/tanimlama">Opsiyon Ekle</el-menu-item>
                <el-menu-item index="/urun/opsiyon/liste">Opsiyon Liste</el-menu-item>
            </el-submenu>
        </el-submenu>
        <el-submenu index="referans" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-contact-mail"></i><span>Referanslar</span>
            </template>
            <el-menu-item index="/referans/tanimlama">
                <span slot="title">Tanımla</span>
            </el-menu-item>
            <el-menu-item index="/referans/liste">
                <span slot="title">Liste</span>
            </el-menu-item>
        </el-submenu>
        <el-submenu index="bayi" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-contacts"></i><span>Bayiler</span>
            </template>
            <el-menu-item index="/bayi/tanimlama">
                <span slot="title">Tanımla</span>
            </el-menu-item>
            <el-menu-item index="/bayi/liste">
                <span slot="title">Liste</span>
            </el-menu-item>
        </el-submenu>
        <el-submenu index="iletisim" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-phone-in-talk"></i><span>İletişim</span>
            </template>
            <el-menu-item index="/iletisim/liste">
                <span slot="title">Liste</span>
            </el-menu-item>
            <el-menu-item index="/iletisim/ayarlar">
                <span slot="title">Ayarlar</span>
            </el-menu-item>
        </el-submenu>
        <el-submenu index="siparis" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-email-open"></i><span>Siparişler</span>
            </template>
            <el-menu-item index="/siparis/liste">
                <span slot="title">Liste</span>
            </el-menu-item>
        </el-submenu>
        <el-menu-item index="/rakamlar/islem">
            <i class="mdi mdi-numeric"></i><span slot="title">Rakamlarla Biz</span>
        </el-menu-item>
        <el-submenu index="galeri" popper-class="main-navigation-submenu">
            <template slot="title">
                <i class="mdi mdi-camera"></i><span>Galeri</span>
            </template>
            <el-menu-item index="/galeri/tanimlama">
                <span slot="title">Tanımla</span>
            </el-menu-item>
            <el-menu-item index="/galeri/liste">
                <span slot="title">Liste</span>
            </el-menu-item>
        </el-submenu>

    </el-menu>
</template>


<script>
    import {detect} from 'detect-browser'

    const browser = detect()
    let base64 = require('base64_js');
    let userDataArtdoor = "", sqlApi = "";
    export default {
        name: 'Nav',
        props: ['mode', 'isCollapse'],
        data() {
            return {
                root: false,
                isIe: true,
                isEdge: true,
                activeLink: null
            }
        },
        methods: {
            goto(index, indexPath) {
                if (index.charAt(0) === '/') {
                    this.$router.push(index)
                    this.$emit('push-page', {page: index})
                }

            },
            setLink(path) {
                this.activeLink = path
            }
        },
        created() {
            if (browser.name !== 'ie') this.isIe = false
            if (browser.name !== 'edge') this.isEdge = false

            this.setLink(this.$router.currentRoute.path)
            this.$router.afterEach((to, from) => {
                this.setLink(this.$router.currentRoute.path)
                //console.log('afterEach', to, from)
            })
            //console.log('this.$router.currentRoute.path', this.$router.currentRoute.path)
        },
        mounted() {
            sqlApi = this.$root.$options.sqlapi;
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                switch (userDataArtdoor.tur) {
                    case "1":
                        this.root = true;
                        break;
                    case "2":

                        break;

                }

            }
            //console.log('nav component mounted')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/_variables';

    .el-menu {
        border: none;
    }

    .el-menu::before, .el-menu::after {
        display: none;
    }

    .el-submenu, .el-menu-item {
        .mdi {
            vertical-align: middle;
            margin-right: 5px;
            display: inline-block;
            width: 24px;
            text-align: center;
            font-size: 18px;
        }
    }
</style>

<style lang="scss">
    @import '../assets/scss/_variables';

    .main-navigation-menu {
        transition: width .5s;

        &:not(.el-menu--collapse) {
            .el-submenu__title, .el-menu-item {
                height: 40px;
                line-height: 40px;
                background-color: transparent !important;
            }


            &:not(.el-menu--horizontal) {
                .el-menu-item, .el-submenu {
                    position: relative;

                    &::before {
                        content: '';
                        display: block;
                        width: 0;
                        height: 1px;
                        position: absolute;
                        bottom: 10px;
                        left: 30px;
                        background: lighten($vertical-navbar-logo-backround, 30%);
                        z-index: 1;
                        opacity: 0;
                        transition: all .7s cubic-bezier(.55, 0, .1, 1);
                    }

                    &:hover {
                        &::before {
                            width: 100px;
                            opacity: 1;
                            //left: 50px;
                            transform: translate(20px, 0);
                        }
                    }

                    &.is-active {
                        &::before {
                            background: $text-color-accent;
                        }
                    }
                }
            }

            .el-submenu.is-opened {
                //background: #edf1f6 !important;
                //background: rgba(223, 228, 234, 0.38) !important;
                position: relative;

                &::after {
                    content: '';
                    display: block;
                    width: 2px;
                    position: absolute;
                    top: 40px;
                    bottom: 10px;
                    left: 31px;
                    background: lighten($vertical-navbar-logo-backround, 30%);
                    z-index: 1;
                }

                &::before {
                    display: none;
                }

                .el-menu-item, .el-submenu {
                    &::before, &::after {
                        display: none;
                    }
                }
            }

            .el-menu-item-group__title {
                padding: 15px 0 0 20px;
                color: $vertical-navbar-title-color;
            }
        }

        .el-submenu__title, .el-menu-item:not(.is-active),a {
            color: $vertical-navbar-menu-item-color;

            i {
                color: $vertical-navbar-menu-item-color;
            }
        }

        &.el-menu--collapse {
            .el-menu-item-group__title {
                padding: 15px 0 0 0;
                width: 100%;
                text-align: center;
            }

            .el-submenu__title:hover, .el-menu-item:hover {
                background-color: rgba(0, 0, 0, 0.05) !important;
            }
        }

        &.el-menu--horizontal {
            white-space: nowrap;
            /*width: fit-content;
            width: max-content;*/
            overflow: hidden;
            display: table;

            & > * {
                float: inherit !important;
                display: inline-block;
            }
        }

        &.nav-collapsed {
            .el-menu-item, .el-submenu__title {
                & > span {
                    display: none;
                }
            }
        }
    }

    .main-navigation-submenu {
        .el-menu {
            background: #fff !important;

            .el-menu-item:not(.is-active) {
                color: $text-color;
            }

            .el-menu-item:hover {
                background-color: transparentize($background-color, 0.3) !important;
            }
        }
    }
</style>
